<template>
    <div id="app">
        <div class="container-fluid">
            <navbar></navbar>
            <router-view :key="$route.fullPath"/>
            <custom-footer></custom-footer>
        </div>
    </div>
</template>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        background: url("assets/background.jpg") repeat;
        min-height: 100vh;
    }

    .container-fluid {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }

    .fill-white {
        filter: invert(100%) sepia(5%) saturate(196%) hue-rotate(194deg) brightness(115%) contrast(100%);
    }
</style>

<script>
    import navbar from './components/navbar';
    import CustomFooter from './components/footer';

    export default {
        name: 'App',
        components: {
            navbar,
            CustomFooter,
        },
        mounted() {
        }
    }
</script>
